import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingActions from "./FloatingActions";
import { Toaster } from "../ui/sonner";

export default function SiteLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <FloatingActions />
      <Toaster
        position="top-center"
        toastOptions={{
          classNames: {
            toast:
              "bg-white border border-brand-line shadow-lg text-brand-ink rounded-none",
          },
        }}
      />
    </div>
  );
}
